import { useEffect } from "react";

import { useRouter } from "next/router";
import PropTypes from "prop-types";

import { actionNames, objectTypes } from "@newsela/snitch";
import AssignmentInstructions from "@/view/AssignmentInstructions";
import focusElementRefKeys from "@/view/constants/focusElementRefKeys";
import useFocusManager from "@/view/utils/useFocusManager";
import contentTypes from "@/view/constants/contentTypes";
import PanelHeader from "../PanelHeader";
import { rootCss, titleCss } from "./AssignmentInstructionsContainer.style";

const propTypes = {
  assignments: PropTypes.array,
  assignmentsLoading: PropTypes.bool,
  closeButtonEventProperties: PropTypes.object,
  data: PropTypes.object,
  shouldFocusCloseButtonRef: PropTypes.object,
  onClickCloseButton: PropTypes.func,
};

const AssignmentInstructionsContainer = ({
  closeButtonEventProperties,
  assignments,
  assignmentsLoading,
  shouldFocusCloseButtonRef,
  onClickCloseButton = () => null,
}) => {
  const router = useRouter();
  const {
    query: { assignmentId, contentId, levelId },
  } = router;

  const assignmentData = assignments.find((assignment) => {
    return assignment.assignment_id === Number(assignmentId);
  });

  const { focusElement } = useFocusManager();

  useEffect(() => {
    focusElement(focusElementRefKeys.activityPanelBackButton);
  }, [contentId]);

  const onClickBackButton = () => {
    const query = { ...router.query };
    // Remove all query params associated with the assignment.
    delete query.activityPanel;
    delete query.assignmentId;
    // Without the assignment query params, the user will return to the activity picker.
    router.replace({ pathname: router.pathname, query }, null, {
      shallow: true,
    });
  };

  const backButtonEventProperties = {
    objectType: objectTypes.assignment,
    actionName: actionNames.navigate,
    streamProperties: {
      content_type: "Article",
      description: "Navigate back to Activity Picker from assignment view",
      content_id: levelId,
      object_id: assignmentId,
    },
  };

  if (!assignmentsLoading && !assignmentData) {
    // reset the query params if the assignment is not available to the current user.
    onClickBackButton();
    return null;
  }

  return (
    <div css={rootCss}>
      <PanelHeader
        backButtonEventProperties={backButtonEventProperties}
        closeButtonEventProperties={closeButtonEventProperties}
        onClickBackButton={onClickBackButton}
        onClickCloseButton={onClickCloseButton}
        shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
      >
        <h2 css={titleCss}>Assignment</h2>
      </PanelHeader>
      <AssignmentInstructions
        assignmentData={assignmentData}
        assignmentsLoading={assignmentsLoading}
        currentLevelId={levelId}
        contentType={contentTypes.ARTICLE}
      />
    </div>
  );
};

AssignmentInstructionsContainer.propTypes = propTypes;

export default AssignmentInstructionsContainer;
